import VueRouter from "vue-router";

/* CSS variables */
export const cssVars = {
    defaultTiming: 350,
};

/* --- Router --- */
const routes: any = [{ path: "/:category" }];
export const router = new VueRouter({ routes });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/global.ts